import { getApiUrlForResource } from '../services/apiUrlResolver';

export const DASHBOARD_RESOURCE_NAME = 'dashboard';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(DASHBOARD_RESOURCE_NAME);

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case 'GET_DASHBOARD_STATS':
            return {
                url: `${getApiUrl()}/${DASHBOARD_RESOURCE_NAME}/stats`,
                options: {
                    method: 'GET'
                }
            };
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    const { json } = httpResponse;
    return { data: json };
};

export default {
    resource: DASHBOARD_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
    customMethods: {
        getDashboardStats: () => ({
            type: 'GET_DASHBOARD_STATS'
        })
    }
}; 